var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"/plan"}},[_c('img',{staticClass:"recommend_plan_update_banner",attrs:{"src":_vm.src,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }